// Design tokens measured from the Framer landing page (jungleai.com) so the
// code rebuild matches it pixel-for-pixel before we start experimenting.
export const landing = {
  color: {
    pageBg: "#FCFFFD",
    heading: "#202220",
    text: "#2F3330",
    body: "#3D3E3D",
    muted: "#9CA3A0",
    label: "#6A6B6A",
    green: "#258548",
    greenHover: "#005720",
    greenDark: "#003D16",
    greenChart: "#2D8A47",
    quoteText: "#0C2100",
    quoteRole: "#6E7571",
    cardGreen: "#F3FCF7",
    inputBg: "#E8F2EC",
    cardBorder: "#EAEDF0",
    navButtonBg: "#EEF0EF",
    footerBg: "#1D4A29",
    footerLink: "#C6D1C7",
  },
  font: {
    heading: '"Tilt Warp", sans-serif',
    body: "Outfit, sans-serif",
    nav: "Inter, sans-serif",
  },
  // Framer's content column is 1000px on desktop; side padding below that.
  contentWidth: "1000px",
  contentSidePadding: { base: "20px", md: "45px", lg: "0px" },
  // Hover treatment shared by the green call-to-action buttons.
  buttonHoverTransition: "background-color 0.25s ease, transform 0.25s ease",
  signUpUrl: "/signup",
  loginUrl: "/login",
  // No storefront segment: Apple opens the visitor's own country's store (the old link forced the UAE one).
  appStoreUrl: "https://apps.apple.com/app/id6657995165",
  googlePlayUrl: "https://play.google.com/store/apps/details?id=com.app.jungleai",
} as const;
